import React, { Component } from "react";

import { MaterialText } from "components/presentation/material-text";

import { MfaVerify } from "../mfa-verify";
import { MfaNumber } from "../mfa-number";
import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";

class MfaEmailEnabled extends Component {
    state = {};

    displayLineTitle() {
        const { classes, title } = this.props;

        return (
            <div className={classes.line}>
                <MaterialText>
                    {title}
                </MaterialText>
            </div>
        );
    }

    displayLineOne() {
        const { userId, orgId, onVerify, classes,rememberMeDays } = this.props;
        const verifyProps = { userId, orgId, onVerify, enabled: true, mfaOption:MFA_AUTHENTICATION_TYPES.EMAIL,rememberMeDays };

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={1} />
                </div>
                <div>
                    <MaterialText>
                        Your two factor authentication app will provide you with
                        a unique code. Enter the code into the confirmation box
                        below:
                    </MaterialText>
                    <div className={classes.verify}>
                        <MfaVerify {...verifyProps} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.displayLineTitle()}
                <div>{this.displayLineOne()}</div>
            </div>
        );
    }
}

export { MfaEmailEnabled };
